import React, { useState ,useEffect} from 'react';
import Select, { components } from 'react-select';
import InputField from "../../../../../common/InputField";
import { COUNTRY_CODE } from "@src/config/constant";
import { useLanguage } from "@src/context/LanguageContext";
import ToggleSwitch from "../../../../../common/ToggleSwitch";

const { ValueContainer, Placeholder } = components;


const CustomValueContainer = ({ children, ...props }:any) => {
  return (
    <ValueContainer {...props}>
      <Placeholder {...props} isFocused={props.isFocused}>
        {props.selectProps.placeholder}
      </Placeholder>
      {React.Children.map(children, (child) =>
        child && child.type !== Placeholder ? child : null
      )}
    </ValueContainer>
  );
};


const BasicSalesDetails = ({ formData, onChange,roleList,salesUserList,agencyAgentData,errors }:any) => {
  const [verticalOption, setVerticalOption] = useState<any>(null);
  const [zoneOption, setZoneOption] = useState<any>(null);

  const {translations} = useLanguage();

  useEffect(() => {
    if (formData.role_id && roleList?.length) {
      const selectedRole = roleList.find((opt: any) => opt.value === formData.role_id);
      if (selectedRole) {
        setZoneOption(selectedRole);
      }
    }
  }, [formData.role_id, roleList]);


  const getReportingRoles = () => {
    if (!zoneOption) return [];

    const selectedIndex = roleList.findIndex((r: any) => r.value === zoneOption.value);

    // for admin
    if (zoneOption.label === "Admin") {
      return [roleList[selectedIndex]];
    }

    // for higher role
    if (!roleList[selectedIndex - 1]) {
      const adminRole = roleList.find((r: any) => r.label === "Admin");
      return adminRole ? [adminRole] : [];
    }

    // in normal case
    return [roleList[selectedIndex - 1]];
  };

const getFilteredUsers = () => {
  if (!formData.reporting_role) return [];

  return salesUserList
    .filter(
      (user: any) =>
        user.role_id === formData.reporting_role && user.status === 1
    )
    .map((user: any) => ({
      value: user.id,
      label: user.name,
    }));
};

  return (
    <React.Fragment>
      <div className="map-filter">
        {/* Name */}
        <fieldset className="form-filed">
          <div className="material">
            <input id="Name" type="text" placeholder=" " className="form-input" onChange={(e) => onChange("name", e.target.value)}  value={formData.name} />
            <label data-label="Name *" className="form-label"></label>
             <span className="error-txt">{errors?.name || ""}</span>
          </div>
        </fieldset>

        {/* Email */}
        <fieldset className="form-filed">
          <div className="material">
            <input id="Email" type="text" placeholder=" " className="form-input" onChange={(e) => onChange("email", e.target.value)}  value={formData.email}/>
            <label data-label="Email *" className="form-label"></label>
             <span className="error-txt">{errors?.email || ""}</span>
          </div>
        </fieldset>

        {/* Mobile */}
        <fieldset className="form-filed">
          <div className="material">
            <InputField
              inputProps={{
                id: "mobile",
                name: "mobile",
                className: "form-input",
                type: "text",
                value: formData.mobile ? formData.mobile : '',
                maxLength: (COUNTRY_CODE === 'id') ? "12" : "10",
                disabled: false,
                placeholder: " "

              }}
              onChange={(e: any) => onChange("mobile", e.target.value)}
            />

            <label data-label={`${translations.RuleEngine?.['Mobile Number'] || translations.commonMsg?.loading} *`} className="form-label">

            </label>
            <span className="error-txt">
              {errors.mobile || ""}
            </span>
          </div>
        </fieldset>

       
        <fieldset className="single-select">
          <div className="material">
            <Select
              components={{ ValueContainer: CustomValueContainer }}
              value={agencyAgentData?.find((opt:any) => opt.value === formData.channel_type) || null}
              onChange={(e) => {
                setVerticalOption(e);
                onChange("channel_type", e?.value);
              }}
              //onChange={setVerticalOption}
              options={agencyAgentData}
              placeholder="Channel Type *"
              className="react-select"
              classNamePrefix="react-select"
            />
             <span className="error-txt">{errors?.channel_type || ""}</span>
          </div>
        </fieldset>

        {/* Password */}
        <fieldset className="form-filed">
          <div className="material">
            <input id="Password" type="text" placeholder=" " className="form-input" onChange={(e) => onChange("password", e.target.value)}  value={formData.password}/>
            <label data-label="Password *" className="form-label"></label>
             <span className="error-txt">{errors?.password || ""}</span>
          </div>
        </fieldset>

        
        <fieldset className="single-select">
          <div className="material">
            <Select
              components={{ ValueContainer: CustomValueContainer }}
              value={roleList?.find((opt: any) => opt.value === formData.role_id) || null}
              onChange={(e: any) => {
                setZoneOption(e);
                onChange("role_id", e?.value);
                onChange("role_slug", e?.slug);
              }}
              options={roleList}
              placeholder="User Role *"
              className="react-select"
              classNamePrefix="react-select"
            />
             <span className="error-txt">{errors?.role_id || ""}</span>

          </div>
        </fieldset>

        
        <fieldset className="single-select">
          <div className="material">
            <Select
              components={{ ValueContainer: CustomValueContainer }}
              //value={stateOption}
              value={getReportingRoles()?.find((opt:any) => opt.value === formData.reporting_role) || null}
              // onChange={(e) => onChange("reporting_role", e.target.value)}
              onChange={(e) => onChange("reporting_role", e?.value)} 
             options={getReportingRoles()}
              placeholder="Reporting to Role *"
              className="react-select"
              classNamePrefix="react-select"
            />
             <span className="error-txt">{errors?.reporting_role || ""}</span>
          </div>

        </fieldset>

        
        <fieldset className="single-select">
          <div className="material">
            <Select
              components={{ ValueContainer: CustomValueContainer }}
               value={getFilteredUsers()?.find((opt:any) => opt.value === formData.reporting_name) || null}
              //onChange={setCitiesOption}
              onChange={(e) => onChange("reporting_name", e.value)}
              options={getFilteredUsers()}
              placeholder="Reporting to Username *"
              className="react-select"
              classNamePrefix="react-select"
            />
             <span className="error-txt">{errors?.reporting_name || ""}</span>
          </div>
        </fieldset>

        <fieldset className="form-filed agency-toggle">
          <div
            className="material status-btn"
            onClick={() => onChange("status", formData.status === 1 ? 0 : 1)}
          >
            <ToggleSwitch checked={String(formData.status) === "1"} />
            <div className="status-txt">
              {String(formData.status) === "1"
                ? translations.commonMsg?.["active"] || translations.commonMsg?.loading
                : translations.commonMsg?.["in_active"] || translations.commonMsg?.loading}
            </div>
          </div>
        </fieldset>
      </div>
    </React.Fragment>
  );
};

export default BasicSalesDetails;
